import { parseISO, isValid } from 'date-fns'

export function isValidISODate(value: string): boolean {
  return isValid(parseISO(value))
}
